const COMPONENT_NAME = "Breadcrumbs";
const COMPONENT_ERROR = `${COMPONENT_NAME}-error : No children prop passed to load the component.`;
export {
  COMPONENT_ERROR,
  COMPONENT_NAME
};
